module.exports = __webpack_public_path__ + "img/FLTST.73e99879.svg";